module.exports = __webpack_public_path__ + "89b112e071a3453e60c7b96f3495b766.ico";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicons/favicon.ico
// module id = 312
// module chunks = 0